<div class="privilege-shell p-2 p-lg-2">
  <div class="privilege-panel">
    <div class="privilege-header">
      <div class="title-wrap">
        <button class="back-btn" type="button" (click)="goBack()">
          <lucide-icon [img]="ChevronLeftIcon" [size]="16"></lucide-icon>
        </button>
        <span class="title-icon">
          <lucide-icon [img]="ShieldCheckIcon" [size]="16"></lucide-icon>
        </span>
        <div>
          <h1 class="m-0">
            Administrator Access
            @if (user(); as currentUser) {
              <span>({{ currentUser.full_name }})</span>
            }
          </h1>
          <p class="m-0">Manage read and write access for staff menus.</p>
        </div>
      </div>

      <button class="btn btn-primary save-btn" type="button" [disabled]="saving() || loading()" (click)="savePrivileges()">
        <lucide-icon [img]="SaveIcon" [size]="14"></lucide-icon>
        <span>{{ saving() ? 'Saving...' : 'Save' }}</span>
      </button>
    </div>

    <div class="toolbar">
      <div class="search-wrap">
        <input class="form-control" placeholder="Search Privilege" [value]="search()" (input)="onSearch(($any($event.target).value || '').toString())" />
        <lucide-icon [img]="SearchIcon" [size]="16" class="search-icon"></lucide-icon>
      </div>

    </div>

    @if (error()) {
      <div class="banner-error">{{ error() }}</div>
    }

    @if (loading()) {
      <div class="empty-state">Loading privileges...</div>
    } @else if (groupedRows().length === 0) {
      <div class="empty-state">No privilege rows found.</div>
    } @else {
      <div class="privilege-body">
        @for (group of groupedRows(); track group.label) {
          <section class="group-card">
            <div class="group-title">{{ group.label }}</div>
            <div class="privilege-subhead">
              <div class="subhead-name">Menu Name</div>
              <div class="subhead-checks">
                <label class="bulk-check heading-check">
                  <input
                    type="checkbox"
                    [checked]="isGroupSelected(group.items, 'can_read')"
                    (change)="toggleGroup(group.items, 'can_read', !!$any($event.target).checked)"
                  />
                  <span>Read</span>
                </label>
                <label class="bulk-check heading-check">
                  <input
                    type="checkbox"
                    [checked]="isGroupSelected(group.items, 'can_write')"
                    (change)="toggleGroup(group.items, 'can_write', !!$any($event.target).checked)"
                  />
                  <span>Write</span>
                </label>
              </div>
            </div>

            @for (row of group.items; track row.menu_id) {
              <div class="privilege-row" [class.parent-row]="isParentRow(row)">
                <div class="name-cell" [style.padding-left.px]="16 + row.level * 20">
                  <span>{{ row.menu_name }}</span>
                </div>

                <div class="checks-cell">
                  <span class="check-slot">
                    <input type="checkbox" [checked]="row.can_read" (change)="toggleRow(row, 'can_read', !!$any($event.target).checked)" />
                  </span>
                  <span class="check-slot">
                    <input type="checkbox" [checked]="row.can_write" (change)="toggleRow(row, 'can_write', !!$any($event.target).checked)" />
                  </span>
                </div>
              </div>
            }
          </section>
        }
      </div>
    }
  </div>
</div>
